import { render, staticRenderFns } from "./curriculumAmountConfigurationList.vue?vue&type=template&id=90942b72"
import script from "./curriculumAmountConfigurationList.vue?vue&type=script&lang=js"
export * from "./curriculumAmountConfigurationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports